import React from "react";
import Slider from "react-slick";
import { HiOutlineArrowRight } from "react-icons/hi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import "./HeroSlider.css";
// Styled-components matching your old setup
const Slide = styled.div`
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 30%;
      left: 125px;
      border: none;
      padding: 10px 20px;
      min-width: max-content;
      border-radius: 10px;
      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      font-size: 16px;
      text-transform: uppercase;
      z-index: 2;

      a {
        color: inherit;
        text-decoration: none;
      }

      svg {
        font-size: 20px;
      }

      @media screen and (max-width: 1024px) {
        left: 88px;
        bottom: 28%;
      }
      @media screen and (max-width: 768px) {
        left: 50%;
        transform: translateX(-50%);
        bottom: 20%;
        font-size: 14px;
        padding: 8px 16px;
      }
      @media screen and (max-width: 480px) {
        bottom: 15%;
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
`;

const ImageContainer = styled.div`
  &.hero {
    // height: 630px;
    width: 100%;
    background-color: #f5f5f5;

    @media screen and (max-width: 1024px) {
      height: 400px;
    }

    @media screen and (max-width: 768px) {
      width: 90%;
      margin: auto;
      height: 230px;
    }

    @media screen and (max-width: 480px) {
      height: 185px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;

      @media screen and (max-width: 768px) {
        border-radius: 10px;
      }
    }
  }
`;

const HeroSlider = ({ heroImages }) => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
  };

  return (
    <Slider {...settings}>
      {heroImages.map((data) => (
        <Slide key={data.id} className="hero">
          <ImageContainer className="hero">
            <img src={data.src} alt="Slide not found" />
          </ImageContainer>
          <button style={{ background: data.bgColor }}>
            <a href={data.route}>Shop Now</a>
            <span>
              <HiOutlineArrowRight />
            </span>
          </button>
        </Slide>
      ))}
    </Slider>
  );
};

export default HeroSlider;
